var _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#D80027"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M400.696,190.009H307.97c5.724-5.994,9.247-14.109,9.247-23.052c0-18.441-14.95-33.391-33.391-33.391 c-11.618,0-21.845,5.936-27.826,14.937c-5.981-9.001-16.209-14.937-27.826-14.937c-18.441,0-33.391,14.95-33.391,33.391 c0,8.943,3.523,17.059,9.247,23.052h-92.725c0,24.589,21.417,44.521,46.004,44.521h-1.484c0,24.59,19.933,44.523,44.523,44.523 c0,7.964,2.099,15.43,5.763,21.894l-36.93,36.931l28.334,28.332l40.192-40.191c1.574,0.577,3.203,1.04,4.885,1.355l-24.287,54.835 L256,422.957l37.695-40.75l-24.287-54.835c1.683-0.315,3.311-0.777,4.885-1.355l40.192,40.191l28.334-28.333l-36.931-36.931 c3.665-6.463,5.764-13.93,5.764-21.894c24.589,0,44.522-19.932,44.522-44.523h-1.483 C379.278,234.529,400.696,214.598,400.696,190.009z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAl);
export default __webpack_public_path__ + "static/media/al.7962bd6f1d568b916baa4fde1b4c236f.svg";
export { ForwardRef as ReactComponent };